import React from "preact/compat";
import {h, Component} from 'preact';
import AsideTextObjectNav from "./AsideTextObjectNav";
import {connect} from "react-redux";
import reduce from "../reducers";
import * as actions from "../actions";
import MenuObject from "../canvas/menu-object";
import AsideMenuObject from "./AsideMenuObject";

export default @connect(reduce, actions)
class AsideText extends Component {
    constructor() {
        super()
    }

    render(props, state) {
        return (<div id="app-aside-text" className="aside-text-new">
            <AsideMenuObject
                uploadedIcons={props.uploadedIcons}
                setUploadedIcons={props.setUploadedIcons} />
        </div>)
    }
}
